import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
export const needsToLoadLocale = consentObject => !getBrowserLanguage() && consentObject.deckLegalConsentEnabled;